import { Withdrawal } from "@workspace/domain/src/features/withdrawal";
import { errorMessage } from "@workspace/domain/src/utils";
import dayjs from "@workspace/domain/src/utils/dayjs";
import Decimal from "decimal.js";
import * as z from "zod";

const WithdrawalEntrySchema = z.object({
  id: z.string(),
  amount: z.number(),
  status: z.enum(Withdrawal.WithdrawalStatus),
  method: Withdrawal.WithdrawalMethod,
  statusDescription: z.string(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

const WithdrawSchema = z.object({
  amount: z
    .number(errorMessage("Amount is required", "Amount is invalid"))
    .min(1, "Amount must be greater than 0")
    .transform((val) => new Decimal(val).times(100).toNumber()),
  method: Withdrawal.WithdrawalMethodWithBankCodes,
  saveMethod: z.boolean(errorMessage("Save method is required", "Save method is invalid")).optional(),
});

const GetAllSchema = z.object({
  startDate: z.union([z.iso.datetime().transform((date) => dayjs(date).toDate()), z.date()]).optional(),
  endDate: z.union([z.iso.datetime().transform((date) => dayjs(date).toDate()), z.date()]).optional(),
  status: z.enum(Withdrawal.WithdrawalStatus).optional(),
  search: z.string().optional(),
  page: z.number().int().min(0),
  limit: z.number().int().min(1).max(1000).default(20),
  sortBy: z.enum(["createdAt", "amount", "status"]),
  sortOrder: z.enum(["asc", "desc"]),
});

const CountSchema = z.object({
  startDate: z.union([z.iso.datetime().transform((date) => dayjs(date).toDate()), z.date()]).optional(),
  endDate: z.union([z.iso.datetime().transform((date) => dayjs(date).toDate()), z.date()]).optional(),
  status: z.enum(Withdrawal.WithdrawalStatus).optional(),
  search: z.string().optional(),
});

export const AdminWithdrawal = {
  Withdraw: WithdrawSchema,
  GetAll: GetAllSchema,
  Count: CountSchema,
  WithdrawalEntry: WithdrawalEntrySchema,
};
export type AdminWithdrawal = {
  Withdraw: z.infer<typeof WithdrawSchema>;
  GetAll: z.infer<typeof GetAllSchema>;
  Count: z.infer<typeof CountSchema>;
  WithdrawalEntry: z.infer<typeof WithdrawalEntrySchema>;
};
